import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import BaseService from "../../../../services/BaseService";
import CourtsService from "../../../../services/CourtsService";

const AddCourtModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		image: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const courtsService = new CourtsService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name_en: item?.name_en,
				name_ar: item?.name_ar,
				location: item?.location,
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();

		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			location: formData?.location,
		};

		setLoading(true);
		if (isAdd) {
			courtsService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			courtsService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.court}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* Name En */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.english_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english_name}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) =>
									setFormData({
										...formData,
										name_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.arabic_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.arabic_name}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										name_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Location */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.location}</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.location}
								bsSize="lg"
								name="location"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.location}
								onChange={(e) =>
									setFormData({
										...formData,
										location: e.target.value,
									})
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.court}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddCourtModal;
